import ExternalApiRequest from "services/externalApiRequest";
import APP from 'app';
import configHelper from 'helper/Config/configHelper';
const { defaultRole = 'CUSTOMER' } = APP.Utils.getConfig();
const { Utils } = APP,
    { isWhitelabel, fetchInfoData, isB2C } = Utils;

const loginConnector = async (data) => {
    const { id = '' } = fetchInfoData();
    try {
        const options = {
            api: "login",
            content: isB2C() ? { ...data, role: defaultRole } : data,
            extraHeaders: isWhitelabel() ? { whitelabel: id } : {}
        };
        return ExternalApiRequest(options);
    } catch (error) {
        return '';
    }
};

export default loginConnector;
